import { render, staticRenderFns } from "./ContainerWorkoutLogExerciseSkeleton.vue?vue&type=template&id=284b87dc&scoped=true"
import script from "./ContainerWorkoutLogExerciseSkeleton.vue?vue&type=script&lang=js"
export * from "./ContainerWorkoutLogExerciseSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284b87dc",
  null
  
)

export default component.exports